import { useEffect, useState } from 'react'

export function usePwaInstallStatus() {
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const checkDisplayMode = () => {
      const isStandalone =
        // iOS Safari
        (window.navigator as any).standalone === true ||
        // Other browsers
        window.matchMedia?.('(display-mode: standalone)').matches ||
        window.matchMedia?.('(display-mode: fullscreen)').matches ||
        window.matchMedia?.('(display-mode: minimal-ui)').matches

      setIsInstalled(isStandalone)
    }

    checkDisplayMode()

    const handleAppInstalled = () => {
      setIsInstalled(true)
      try {
        window.localStorage.setItem('binyuma:pwa-installed', 'true')
      } catch {
        // ignore
      }
    }

    window.addEventListener('appinstalled', handleAppInstalled)

    try {
      if (window.localStorage.getItem('binyuma:pwa-installed') === 'true') {
        setIsInstalled(true)
      }
    } catch {
      // ignore
    }

    return () => {
      window.removeEventListener('appinstalled', handleAppInstalled)
    }
  }, [])

  return isInstalled
}

